window.I18n.translations.en.comparisonShoppingPage = {
  listingTab: {
    used: 'Used',
    new: 'New',
    usedNew: 'Used or New',
    zeroListings: '0 Listings',
    countFromPrice: '{{count}} from {{price}}',
    emptyStateImgAlt: 'No listings icon',
    noListings: 'There are no listings that ship to you.',
    tryChangingRegion: 'Try {{linkOpen}}changing your shipping region{{linkClose}}.',
    youCanChangeHint: 'You can always change this back using the shipping region toggle in the footer.'
  },
  reviews: {
    one: '1 Review',
    other: '{{count}} Reviews'
  },
  learnMore: 'Learn more',
  aboutProduct: 'about this product',
  localeCallout: {
    global: 'Showing all active listings. {{openLinkTag}}Click here{{closeLinkTag}} to only show listings that ship to {{countryName}}.',
    local: 'Showing only listings that ship to {{countryName}}. {{openLinkTag}}Click here{{closeLinkTag}} to show all active listings.'
  },
  priceHistoryTab: {
    priceHistory: 'Price History',
    priceRange: '{{lowPrice}} to {{highPrice}}'
  },
  productSpecs: 'Product Specs',
  productDescription: 'Description'
};



// WEBPACK FOOTER //
// ./javascripts/translations/comparison_shopping_page/en.js